import { useEffect, useState } from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

//Assets
import loading_yellow from "../../assets/loading_yellow.svg";
import connector_bg from "../../assets/connecter_bg.svg";
import { ReactComponent as ConnectorBg } from '../../assets/connecter_bg.svg'

//Components
import WalletInfoCopy from "../../components/WalletInfoCopy";
import Web3 from "web3";
import NFT_ABI from "../../constants/nft_abi";
import env from "../../constants/env";
import { useSelector } from "react-redux";
import axios from "axios";
import { RootState } from "../../redux/store";
import { MOBILE } from "../../constants/breakpoints";
import { SignatureVerificationSection } from "./SignatureVerificationSection";

const MovingSection = ({
  selectedProxyTokenInitMint,
  nftData,
  nftMovedToStorage,
  setNftMovedToStorage,
  setProxyTokenMintData,
}: {
  selectedProxyTokenInitMint: any;
  nftData: any;
  nftMovedToStorage: any;
  setNftMovedToStorage: any;
  setProxyTokenMintData: any;
}) => {
  const [web3, setWeb3] = useState<any>();

  let wallet = useSelector((state: RootState) => state.walletState);

  useEffect(() => {
    if (!selectedProxyTokenInitMint) {
      return;
    }
    try {
      let temp_web3 =
        selectedProxyTokenInitMint.nft_asset_chain == "1"
          ? new Web3(env.ETH_RPC_URL)
          : new Web3(env.POLYGON_RPC_URL);
      setWeb3(temp_web3);
    } catch (error) {
      console.warn('failed to connect with rpc', error)
    }
  }, [selectedProxyTokenInitMint]);

  useEffect(() => {
    const verifyNftTransfer = async () => {
      if (!web3) {
        return false;
      }

      const {
        nft_asset_chain,
        nft_asset_contract_address,
        nft_asset_id,
        asset_storage_wallet_address,
        proxy_token_id,
      } = selectedProxyTokenInitMint;
      const whiteListedDataStr = localStorage.getItem('WHITE_LISTED_CONTRACTS') || '{}'
      const whiteListedData = JSON.parse(whiteListedDataStr)
      const [contractData] = whiteListedData?.filter((el: any) => el?.nft_asset_contract_address?.toLowerCase() === nft_asset_contract_address?.toLowerCase())
      const contractAbiStr = contractData?.contract_abi || '{}'
      const contractAbi = JSON.parse(contractAbiStr)

      // TODO: verify the current owner of the NFT asset on solana
      const nftContract = new web3.eth.Contract(
        contractAbi ?? NFT_ABI,
        nft_asset_contract_address
      );
      const nftOwner = await nftContract.methods.ownerOf(nft_asset_id).call();
      let adminSignaturDone: any;
      try {
        adminSignaturDone = await axios.get(
          `${env.USER_URL}/proxy-token-mint/proxyToken/${proxy_token_id}`,
          {
            headers: {
              Authorization: `Bearer ${wallet.jwtToken}`,
            },
          }
        );
      } catch (error) {
        console.error(error);
        return false;
      }


      if (!adminSignaturDone?.data?.admin_tx_signature) {
        return false;
      }

      if (
        nftOwner.toLowerCase() !== asset_storage_wallet_address.toLowerCase() &&
        adminSignaturDone.data.admin_tx_signature == ""
      ) {
        return false;
      }

      setNftMovedToStorage(true);
      setProxyTokenMintData(adminSignaturDone.data);
      return true;
    };

    let intervalId: any;
    if (nftMovedToStorage) {
      clearInterval(intervalId);
    } else {
      intervalId = setInterval(() => {
        // Function to run every 10 seconds
        try {
          verifyNftTransfer();
        } catch (error) {
          console.warn('failed to verifyNftTransfer', error)
        }
      }, 5000);
    }

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, [nftMovedToStorage, web3]);

  if (selectedProxyTokenInitMint?.proxy_token_mint_method !== "TOKEN_TRANSFER") {
    return <SignatureVerificationSection isVerified={nftMovedToStorage} assetWallet={wallet.assetAddress ?? ""} selectedProxyTokenInitMint={selectedProxyTokenInitMint} />
  }

  return (
    <section
      css={css`
          display: flex;
          margin-top: 40px;
          border: 1px solid #ccc4b3;
          border-radius: 12px;
          padding: 32px;
          flex-direction: column;

          @media (max-width: ${MOBILE}px) {
            width: 100%;
            height: max-content;
            padding: 16px 24px;
          }
        `}
    >
      <div
        css={css`
            display: 100%;
            display: flex;
          `}
      >
        <span
          css={css`
              display: flex;
              flex-direction: column;
              width: 75%;
              margin-top: 70px;

              @media (max-width: ${MOBILE}px) {
                margin-top: 0;
              }
            `}
        >
          <h1
            css={css`
                font-weight: 700;
                font-size: 24px;
                margin: 0;

                @media (max-width: ${MOBILE}px) {
                  font-size: 16px;
                  width: 80%;
                }
              `}
          >
            Move your asset to it's destination
          </h1>
        </span>
        <img
          css={css`
              width: 128px;
              height: 128px;

              @media (max-width: ${MOBILE}px) {
                width: 64px;
                height: 64px;
              }
            `}
          src={loading_yellow}
          alt=""
        />
      </div>
      <div
        css={css`
            display: flex;
            flex-direction: column;
            margin-top: 36px;
          `}
      >
        <WalletInfoCopy
          label_text={"Asset Wallet ID"}
          value={selectedProxyTokenInitMint.asset_owner_wallet_address}
          active_border={true}
        />
        <ConnectorBg
          css={css`
            display: flex;
            width: 374.94px;
            height: 64.56px;

            @media (max-width: ${MOBILE}px) {
              width: 250px;
            }

            margin: 0 auto;
            /* background-image: url(${connector_bg}); */
        `}
        />
        {/* <span
          css={css`
              display: flex;
              width: 374.94px;
              height: 64.56px;

              @media (max-width: ${MOBILE}px) {
                width: 70%;
              }

              margin: 0 auto;
              background-image: url(${connector_bg});
            `}
        ></span> */}
        <WalletInfoCopy
          value={selectedProxyTokenInitMint.asset_storage_wallet_address}
          active_border={nftMovedToStorage}
          label_text={"Storage Wallet ID"}
        />
      </div>
    </section>
  );
};

export default MovingSection;
